import React, { useEffect } from 'react';
import AddYear from '../ManageCompanies/AddYear';
import ManageClients from '../ManageCompanies/ManageClients';

function ManageDocument({ selectedCompany }) {
  /// Title Specification ///

  useEffect(() => {
    document.title = 'Manage Document - Add Document Types and Manage Documents';
  }, []);

  /// HTML Component ///

  return (
    <div className="font-body flex flex-col items-center justify-center h-[100%] py-12 w-[90%] md:w-[70%] lg:w-[50%] mx-auto">
      <AddYear selectedCompany={selectedCompany} />
      <div className="h-10"></div>
      <ManageClients selectedCompany={selectedCompany} />
    </div>
  );
}

export default ManageDocument;
